'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _inputHandler = require('../inputsFunctions/inputHandler');
var _inputHandler2 = _interopRequireDefault(_inputHandler);
var _wavfichacertaFichacertaFieldsTemplates = require('@bit/wavfichacerta.fichacerta.fields-templates.phone');
var _CustomMaskedInput = require('./CustomMaskedInput');
var _CustomMaskedInput2 = _interopRequireDefault(_CustomMaskedInput);
var _inputsStyles = require('../inputsStyles/inputsStyles');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var types = {
  maskedText: _CustomMaskedInput2.default
};
var handler = (0, _inputHandler2.default)(types);
var DynamicPhoneGroup = function (_PureComponent) {
  _inherits(DynamicPhoneGroup, _PureComponent);
  function DynamicPhoneGroup() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, DynamicPhoneGroup);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DynamicPhoneGroup.__proto__ || Object.getPrototypeOf(DynamicPhoneGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      fields: _this.props.phoneFields
    }, _this.handleComposedFields = function (field) {
      var size = _this.props.size;
      return handler(Object.assign({}, field, {
        size: size
      }));
    }, _this.renderFields = function () {
      var fields = _this.state.fields;
      var theme = _this.props.theme;
      if (Array.isArray(fields) && fields.length > 0) {
        var fieldsToRender = fields.map(function (field, index) {
          var newField = field;
          if (index === 1) {
            newField.after = _react2.default.createElement(_inputsStyles.SignButtonContainer, {
              onClick: _this.removeField
            }, _react2.default.createElement(_inputsStyles.IconContainer, null, _react2.default.createElement(_inputsStyles.MinusSVG, {
              width: '1rem',
              height: '1rem',
              fill: theme.dynamicPhoneButtonColor
            })));
          } else if (fields.length === 1) {
            newField.after = _react2.default.createElement(_inputsStyles.SignButtonContainer, {
              onClick: _this.addField
            }, _react2.default.createElement(_inputsStyles.IconContainer, null, _react2.default.createElement(_inputsStyles.PlusSVG, {
              width: '1rem',
              height: '1rem',
              fill: theme.dynamicPhoneButtonColor
            })));
          } else {
            newField.after = null;
          }
          return _this.handleComposedFields(newField);
        });
        return fieldsToRender;
      }
      return null;
    }, _this.addField = function (e) {
      e.preventDefault();
      if (!_this.props.theme.disabled) {
        _this.setState({
          fields: [].concat(_toConsumableArray(_this.state.fields), [(0, _wavfichacertaFichacertaFieldsTemplates.defaultPhoneWithoutDDI)('telefones.adicional.numero', 'Telefone Adicional')])
        });
      }
    }, _this.removeField = function (e) {
      e.preventDefault();
      if (!_this.props.theme.disabled) {
        _this.setState(function (state) {
          var popedFieldList = state.fields;
          popedFieldList.pop();
          return {
            fields: popedFieldList
          };
        });
        _this.props.unregisterField(_this.props.formName, 'telefones.adicional.numero');
        _this.props.clearFields(_this.props.formName, true, true, 'telefones.adicional.numero');
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(DynamicPhoneGroup, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_react.Fragment, null, this.renderFields());
    }
  }]);
  return DynamicPhoneGroup;
}(_react.PureComponent);
exports.default = DynamicPhoneGroup;